import { session } from "./session";

export interface LevelCat { icon: string; name: string; nameM: string; }
export interface LevelDef { min: number; icon: string; name: string; nameM: string; cat: number; }

const LEVEL_CATS: LevelCat[] = [
  { icon: "🐣", name: "Nováčik", nameM: "Nováčik" },
  { icon: "🌱", name: "Zelenáč", nameM: "Zelenáč" },
  { icon: "🔥", name: "Zapálenec", nameM: "Zapálenec" },
  { icon: "💪", name: "Vytrvalec", nameM: "Vytrvalec" },
  { icon: "⚙️", name: "Stroj", nameM: "Stroj" },
  { icon: "🛡️", name: "Bojovník", nameM: "Bojovník" },
  { icon: "🦾", name: "Majster", nameM: "Majster" },
  { icon: "🧠", name: "Guru", nameM: "Guru" },
  { icon: "🏆", name: "Šampión", nameM: "Šampión" },
  { icon: "👑", name: "Legenda", nameM: "Legenda" },
  { icon: "🌟", name: "Mýtický", nameM: "Mýtický" },
  { icon: "⚡", name: "Super Godlike", nameM: "Super Godlike" },
];
// v2 — Level 0 „Deň nula" is a virtual pre-level for a brand-new user (0–4 b). The first
// tutorial návyk (+5 b) grants Level 1 „Totálne newbie". Deň nula is NOT part of the 60-level
// grid; levelIndex returns -1 for it and getLevel maps that to this object.
const DEN_NULA: LevelDef = { min: 0, icon: "🥚", name: "Deň nula", nameM: "Deň nula", cat: -1 };
// Všetky názvy levelov sú rodovo neutrálne (name === nameM): namiesto tvarov, čo by rozlišovali
// muža/ženu (Vytrvalec/Vytrvalkyňa…), používame neutrálne podstatné mená, metafory a stavy.
const LEVELS: LevelDef[] = [
  { min: 5, icon: "🐣", name: "Totálne newbie", nameM: "Totálne newbie", cat: 0 },
  { min: 65, icon: "🎮", name: "Mačkanie tlačidiel", nameM: "Mačkanie tlačidiel", cat: 0 },
  { min: 140, icon: "📗", name: "Tutoriálová úroveň", nameM: "Tutoriálová úroveň", cat: 0 },
  { min: 210, icon: "👶", name: "Ešte sa učí chodiť", nameM: "Ešte sa učí chodiť", cat: 0 },
  { min: 300, icon: "✊", name: "Prvý boss padol", nameM: "Prvý boss padol", cat: 0 },
  { min: 390, icon: "🌱", name: "Prvé výhonky", nameM: "Prvé výhonky", cat: 1 },
  { min: 490, icon: "🌿", name: "Húževnatý sadeník", nameM: "Húževnatý sadeník", cat: 1 },
  { min: 600, icon: "⛽", name: "Naberá grády", nameM: "Naberá grády", cat: 1 },
  { min: 720, icon: "🎵", name: "Chytá rytmus", nameM: "Chytá rytmus", cat: 1 },
  { min: 850, icon: "📅", name: "Ako hodinky", nameM: "Ako hodinky", cat: 1 },
  { min: 990, icon: "🔥", name: "V jednom ohni", nameM: "V jednom ohni", cat: 2 },
  { min: 1150, icon: "🚂", name: "Rozbehnutý vlak", nameM: "Rozbehnutý vlak", cat: 2 },
  { min: 1350, icon: "🏃", name: "Bez zastavenia", nameM: "Bez zastavenia", cat: 2 },
  { min: 1500, icon: "🌊", name: "Na vlne", nameM: "Na vlne", cat: 2 },
  { min: 1750, icon: "✨", name: "Horiaca séria", nameM: "Horiaca séria", cat: 2 },
  { min: 1950, icon: "💪", name: "Vytrvalosť", nameM: "Vytrvalosť", cat: 3 },
  { min: 2200, icon: "🐂", name: "Hlavou cez múr", nameM: "Hlavou cez múr", cat: 3 },
  { min: 2500, icon: "⚙️", name: "Železná vôľa", nameM: "Železná vôľa", cat: 3 },
  { min: 2850, icon: "🚫", name: "Bez výhovoriek", nameM: "Bez výhovoriek", cat: 3 },
  { min: 3200, icon: "🏅", name: "Na dlhé trate", nameM: "Na dlhé trate", cat: 3 },
  { min: 3600, icon: "⚙️", name: "Stroj na návyky", nameM: "Stroj na návyky", cat: 4 },
  { min: 4000, icon: "🛸", name: "Autopilot", nameM: "Autopilot", cat: 4 },
  { min: 4500, icon: "🔧", name: "Dobre namazaný stroj", nameM: "Dobre namazaný stroj", cat: 4 },
  { min: 5100, icon: "🤖", name: "Bez zľutovania", nameM: "Bez zľutovania", cat: 4 },
  { min: 5700, icon: "♾️", name: "Perpetuum mobile", nameM: "Perpetuum mobile", cat: 4 },
  { min: 6400, icon: "🛡️", name: "V plnej zbroji", nameM: "V plnej zbroji", cat: 5 },
  { min: 7100, icon: "⚔️", name: "Aréna volá", nameM: "Aréna volá", cat: 5 },
  { min: 8000, icon: "🥋", name: "Disciplína v tele", nameM: "Disciplína v tele", cat: 5 },
  { min: 9000, icon: "🪨", name: "Tvrdé jadro", nameM: "Tvrdé jadro", cat: 5 },
  { min: 10100, icon: "🎖️", name: "Veteránske zásluhy", nameM: "Veteránske zásluhy", cat: 5 },
  { min: 11300, icon: "🦾", name: "Majstrovstvo", nameM: "Majstrovstvo", cat: 6 },
  { min: 12700, icon: "🥷", name: "Sensei", nameM: "Sensei", cat: 6 },
  { min: 14300, icon: "🎻", name: "Virtuozita", nameM: "Virtuozita", cat: 6 },
  { min: 16100, icon: "🧘", name: "Hlboké sústredenie", nameM: "Hlboké sústredenie", cat: 6 },
  { min: 18100, icon: "♟️", name: "Veľmajstrovstvo", nameM: "Veľmajstrovstvo", cat: 6 },
  { min: 20500, icon: "🧠", name: "Guru", nameM: "Guru", cat: 7 },
  { min: 23000, icon: "📜", name: "Múdrosť", nameM: "Múdrosť", cat: 7 },
  { min: 26000, icon: "🕯️", name: "Osvietenie", nameM: "Osvietenie", cat: 7 },
  { min: 29500, icon: "🧭", name: "Mentorstvo", nameM: "Mentorstvo", cat: 7 },
  { min: 33500, icon: "📣", name: "Koučovanie životov", nameM: "Koučovanie životov", cat: 7 },
  { min: 37500, icon: "🏆", name: "Na pódiu", nameM: "Na pódiu", cat: 8 },
  { min: 42500, icon: "📈", name: "Rekordy padajú", nameM: "Rekordy padajú", cat: 8 },
  { min: 48500, icon: "🛡️", name: "Neporaziteľnosť", nameM: "Neporaziteľnosť", cat: 8 },
  { min: 55000, icon: "🏛️", name: "Sieň slávy", nameM: "Sieň slávy", cat: 8 },
  { min: 62500, icon: "🌟", name: "Ikona", nameM: "Ikona", cat: 8 },
  { min: 71500, icon: "👑", name: "Legenda", nameM: "Legenda", cat: 9 },
  { min: 81500, icon: "🦁", name: "Živá legenda", nameM: "Živá legenda", cat: 9 },
  { min: 93000, icon: "🐉", name: "Mýtus", nameM: "Mýtus", cat: 9 },
  { min: 107000, icon: "🗿", name: "Titanská sila", nameM: "Titanská sila", cat: 9 },
  { min: 122000, icon: "🌓", name: "Polobožstvo", nameM: "Polobožstvo", cat: 9 },
  { min: 140000, icon: "🌟", name: "Mýtus ožíva", nameM: "Mýtus ožíva", cat: 10 },
  { min: 161000, icon: "💫", name: "Medzi hviezdami", nameM: "Medzi hviezdami", cat: 10 },
  { min: 185000, icon: "☄️", name: "Kozmické rozmery", nameM: "Kozmické rozmery", cat: 10 },
  { min: 213000, icon: "🛸", name: "Nadpozemské sféry", nameM: "Nadpozemské sféry", cat: 10 },
  { min: 245000, icon: "⏳", name: "Nesmrteľnosť", nameM: "Nesmrteľnosť", cat: 10 },
  { min: 283000, icon: "⚡", name: "Godlike", nameM: "Godlike", cat: 11 },
  { min: 327000, icon: "🌌", name: "Vláda nad vesmírom", nameM: "Vláda nad vesmírom", cat: 11 },
  { min: 378000, icon: "🕳️", name: "Nad časom a priestorom", nameM: "Nad časom a priestorom", cat: 11 },
  { min: 438000, icon: "🔱", name: "Absolútna sila", nameM: "Absolútna sila", cat: 11 },
  { min: 509000, icon: "🦄", name: "Super Godlike", nameM: "Super Godlike", cat: 11 },
];
// -1 = Level 0 „Deň nula" (below the first real level, i.e. under 5 b)
const levelIndex = (p: number): number => { let i = -1; for (let k = 0; k < LEVELS.length; k++) if (p >= LEVELS[k].min) i = k; return i; };
const getLevel = (p: number): LevelDef => { const i = levelIndex(p); return i < 0 ? DEN_NULA : LEVELS[i]; };
const nextLevel = (p: number): LevelDef | null => LEVELS.find((l) => l.min > p) || null;
// názvy sú rodovo neutrálne (name === nameM); gname ostáva pre spätnú kompatibilitu rozhrania
const gname = (lvl: LevelDef | null | undefined): string => (lvl ? (session.gender === "m" ? lvl.nameM : lvl.name) : "");

export { LEVEL_CATS, LEVELS, DEN_NULA, levelIndex, getLevel, nextLevel, gname };
